import { Link } from "react-router-dom";

export default function AgbPage() {
  return (
    <div className="container max-w-3xl py-16">
      <h1 className="font-display text-3xl font-bold tracking-tight text-foreground">
        Allgemeine Geschäftsbedingungen (AGB)
      </h1>
      <p className="mt-2 text-sm text-muted-foreground">Stand: {new Date().toLocaleDateString("de-DE")}</p>

      <div className="mt-10 space-y-8 text-base leading-relaxed text-muted-foreground">
        <section>
          <h2 className="font-display text-lg font-bold text-foreground">1. Geltungsbereich</h2>
          <p className="mt-2">
            Diese AGB gelten für alle Verträge über die Nutzung des Dienstes Torflash zwischen David Federl
            (nachfolgend „Anbieter") und dem Kunden (Verein, Verband oder sonstige Organisation). Abweichende
            Bedingungen des Kunden gelten nur bei ausdrücklicher schriftlicher Zustimmung.
          </p>
        </section>

        <section>
          <h2 className="font-display text-lg font-bold text-foreground">2. Leistungsbeschreibung</h2>
          <p className="mt-2">
            Torflash erstellt aus öffentlich verfügbaren Spieldaten automatisch Grafiken (z. B. Instagram Stories) im
            Design des Kunden und stellt diese zum Download bzw. zur Weiterleitung per Messenger bereit. Der Anbieter
            schuldet keine bestimmte Reichweite, keine Veröffentlichung auf Drittplattformen und keine
            unterbrechungsfreie Verfügbarkeit. Torflash steht in keiner offiziellen Verbindung zum BFV.
          </p>
        </section>

        <section>
          <h2 className="font-display text-lg font-bold text-foreground">3. Vertragsschluss</h2>
          <p className="mt-2">
            Der Vertrag kommt mit Abschluss des Bestellvorgangs (Klick auf den Zahlungsbutton) und Bestätigung durch den
            Anbieter zustande. Der Kunde sichert zu, zur Vertretung des angegebenen Vereins berechtigt zu sein.
          </p>
        </section>

        <section>
          <h2 className="font-display text-lg font-bold text-foreground">4. Preise und Zahlung</h2>
          <p className="mt-2">
            Es gelten die zum Zeitpunkt der Bestellung auf der Website angegebenen Preise. Der Anbieter ist
            Kleinunternehmer gemäß § 19 UStG; es wird keine Umsatzsteuer berechnet oder ausgewiesen. Die Abrechnung erfolgt monatlich im

            Voraus über unseren Zahlungsdienstleister Stripe (u. a. Kreditkarte, PayPal, Apple&nbsp;Pay,
            Google&nbsp;Pay, Klarna, SEPA-Lastschrift – abhängig von Verfügbarkeit). Bei Zahlungsverzug kann der
            Anbieter die Leistung bis zum Zahlungseingang aussetzen.
          </p>
        </section>

        <section>
          <h2 className="font-display text-lg font-bold text-foreground">5. Laufzeit und Kündigung</h2>
          <p className="mt-2">
            Abos laufen monatlich und können jederzeit zum Ende des laufenden Abrechnungszeitraums gekündigt werden.
            Die Kündigung erfolgt formlos per E-Mail an{" "}
            <a href="mailto:info@torflash.de" className="text-primary underline">info@torflash.de</a> oder über das
            Kundenkonto. Einmalige Leistungen (z. B. Individuelles Paket) sind von der Kündigung nicht betroffen.
          </p>
        </section>

        <section>
          <h2 className="font-display text-lg font-bold text-foreground">6. Widerrufsrecht</h2>
          <p className="mt-2">
            Ein gesetzliches Widerrufsrecht besteht nur für Verbraucher. Vereine und Unternehmer handeln in der Regel
            nicht als Verbraucher; in diesem Fall besteht kein Widerrufsrecht. Sofern ein Widerrufsrecht besteht, kann
            der Vertrag binnen 14 Tagen ohne Angabe von Gründen in Textform widerrufen werden.
          </p>
        </section>

        <section>
          <h2 className="font-display text-lg font-bold text-foreground">7. Pflichten des Kunden</h2>
          <p className="mt-2">
            Der Kunde stellt sicher, dass er an hochgeladenen Inhalten (insbesondere Vereinswappen, Logos, Fotos) die
            erforderlichen Rechte besitzt, und stellt den Anbieter von Ansprüchen Dritter frei. Zugangsdaten sind
            geheim zu halten.
          </p>
        </section>

        <section>
          <h2 className="font-display text-lg font-bold text-foreground">8. Verfügbarkeit</h2>
          <p className="mt-2">
            Der Anbieter bemüht sich um eine hohe Verfügbarkeit, schuldet jedoch keine bestimmte Uptime. Wartungen und
            Störungen bei Drittanbietern (z. B. Datenquellen, Messenger, Hosting) können zu Einschränkungen führen.
          </p>
        </section>

        <section>
          <h2 className="font-display text-lg font-bold text-foreground">9. Haftung</h2>
          <p className="mt-2">
            Der Anbieter haftet unbeschränkt bei Vorsatz und grober Fahrlässigkeit sowie bei Verletzung von Leben,
            Körper und Gesundheit. Bei einfacher Fahrlässigkeit haftet er nur bei Verletzung wesentlicher
            Vertragspflichten und begrenzt auf den vertragstypischen, vorhersehbaren Schaden. Eine Haftung für die
            Richtigkeit automatisiert übernommener Spieldaten ist ausgeschlossen.
          </p>
        </section>

        <section>
          <h2 className="font-display text-lg font-bold text-foreground">10. Datenschutz</h2>
          <p className="mt-2">
            Informationen zur Verarbeitung personenbezogener Daten finden sich in der{" "}
            <Link to="/datenschutz" className="text-primary underline">Datenschutzerklärung</Link>.
          </p>
        </section>

        <section>
          <h2 className="font-display text-lg font-bold text-foreground">11. Änderungen der AGB</h2>
          <p className="mt-2">
            Der Anbieter kann diese AGB mit Wirkung für die Zukunft ändern. Kunden werden mindestens 30 Tage vor
            Inkrafttreten per E-Mail informiert und können bis dahin widersprechen bzw. kündigen.
          </p>
        </section>

        <section>
          <h2 className="font-display text-lg font-bold text-foreground">12. Schlussbestimmungen</h2>
          <p className="mt-2">
            Es gilt deutsches Recht. Gerichtsstand ist – soweit zulässig – der Sitz des Anbieters. Sollten einzelne
            Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
          </p>
          <p className="mt-4">
            Anbieter: David Federl, Breslauer Straße 22, 82140 Olching ·{" "}
            <a href="mailto:info@torflash.de" className="text-primary underline">info@torflash.de</a> · Kleinunternehmer
            gemäß § 19 UStG, es wird keine Umsatzsteuer ausgewiesen.
          </p>

        </section>
      </div>
    </div>
  );
}
